import { render } from "./Reperibilita.vue?vue&type=template&id=5df075df&scoped=true"
import script from "./Reperibilita.vue?vue&type=script&lang=js"
export * from "./Reperibilita.vue?vue&type=script&lang=js"

import "./Reperibilita.vue?vue&type=style&index=0&id=5df075df&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df075df"]])

export default __exports__